module.exports = __webpack_public_path__ + "img/traffic_checked.6480dfc9.png";